<template>
	<div class="industrialpark" >
		<leftnav class="fl" mkcode="C" itemcode="B-DDTP"></leftnav> 
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage" v-if="userdata.groupType != 2 && this.userdata.token">
				
			<div class="index_block whitebox right_topbox" style="padding-bottom: 1px;">
				<div class="map_title_tab"> 
					<span :class="areatype == 'province' ? 'title red-icon current':'title red-icon'"  @click="routerself('industryChain?type=province')">产业链现状图({{userdata.provinceText}})</span>
					<!-- 当前版本为招商研究投资且为直辖市时不展示   -->
					<span :class="areatype == 'city' ? 'title current':'title'" @click="routerself('industryChain?type=city')">产业链现状图({{userdata.currentCity.text}})</span>
					<span class="title" @click="routerself('/investment-clues2')" >本地龙头企业产业链上下游</span>
				</div> 
					<ul class="hotchain-list oh">
						<li :key="index" v-for="(list,index) in resdata" @click="routerself('/localChain?id='+list.chainId+'&type='+calCuData.type)" class="fl">
							<div class="imgbox"><img :src="list.image" v-bind:alt="list.chainName"></div>
								<h5 class="title">{{list.chainName}}</h5> 
						</li>
					</ul>
				</div>
				<div class="whitebox right_topbox">
					<div class="right_boxtitle">
						<span class="fl right_title" :data-id="userdata.city">{{calCuData.text}}产业图谱（按产业分类）</span> 
						 <span class="chanyeshezhi fr" @click="routerlinkid('/chainNotions')">产业设置</span>
					</div>  
					 
					<dl class="opport-screen bdbe" v-show="tiptext==''">
						<dt class="fl">产业分类</dt>
						<dd class="fl screenop"> 
							<span :key="index" v-for="(item,index) in newnotionlist" v-show="item.childrenList.length>0 && item.label.indexOf('未来')<0"  :class="notioncodeA == item.value ?'a-screen current':'a-screen'" @click="atTimeSelect(item,1)">{{item.label}}</span>
						</dd>
					</dl>
					<dl class="opport-screen bdbe" v-show="notionlist1.length>0">
						<dt class="fl titleop">二级分类</dt>
						<dd class="fl"> 
							<span :key="index" v-for="(item,index) in notionlist1" :class="notioncodeB == item.value ?'a-screen current':'a-screen'"   @click="atTimeSelect(item,2)">{{item.label}}<em class="num" v-show="item.num">({{item.num}})</em></span>
						</dd>
					</dl>
					<dl class="opport-screen bdbe" v-show="notionlist2.length>0">
						<dt class="fl titleop">产业链</dt>
						<dd class="fl"> 
							<span :key="index" v-for="(item,index) in notionlist2" :class="notionCode == item.notionCode ?'a-screen current':'a-screen'" @click="atTimeSelect(item,3)">{{item.notionName}}<em class="num" v-show="item.num">({{item.num}})</em></span>
						</dd>
					</dl>
					<p v-show="tiptext!=''" class="tiptext-screen">{{tiptext}}</p>
					</div>
				 
				<div class="whitebox" style="padding-bottom: 50px;margin-top: 10px;padding-top:40px">
					<!-- <div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" >产业大脑为您找到相关企业<span class="searchnum orangefont">{{total}}</span>家 </p> 
					</div> -->
					<div class="enterprise_list_box"  >
						<div class="scrollBox" :key="i" v-for="(list,i) in notionlist3">
							<div class="notionComlist oh"  :style="'width:'+((list.children.length * 410 )+350)+'px'">
								<div class="bigbox notioncombox">
									<h5 class="title">{{list.notionName}}</h5>
									<div class="oh">
											<span :class="list.chainType== '建链' ?'chainType jian':'chainType qiang'" v-show="list.chainType!=''">{{list.chainType}}</span>
											<span class="clickmore" @click="routerlinkarry('/chainEnterpriselist',{code:list.notionCode,type:0,title:list.notionName})" v-show="list.enterprise[0].list.length>2||list.enterprise[1].list.length>2||list.enterprise[2].list.length>2||list.enterprise[3].list.length>2">更多></span>
											<!-- v-show="list.chainType == '建链'" -->
											<span class="focuslink" v-show="list.enterprise[0].list.length<3&&list.enterprise[1].list.length<3&&list.enterprise[2].list.length<3&&list.enterprise[3].list.length<3" @click="tagrouter('/targetEnterprise',0,'notion',list.notionCode,list.notionName)">{{marketStr ?'相关企业推荐':'目标招商企业'}}></span>
										<dl>
											<dt>上市</dt>
											<dd>
												 <span class="a-router" :class="userdata.areaKey == item.areaKey?'curp current':''" :key="index" v-for="(item,index) in list.enterprise[0].list" @click="routerlinkid('/enterprises',item.stockCode)">{{item.title}}</span>
											</dd>
											<!-- <span class="clickmore" @click="routerlinkarry('/chainEnterpriselist',{code:list.notionCode,type:9,title:list.notionName})" v-show="list.enterprise[0].list.length>2">更多</span> -->
										</dl>
										<dl>
											<dt>龙头</dt>
											<dd>
												 <span class="a-router" :class="userdata.areaKey == item.areaKey?'curp current':''" :key="index" v-for="(item,index) in list.enterprise[1].list" @click="routerlinkid('/enterprises',item.stockCode)" >{{item.title}}</span>
											</dd>
											<!-- <span class="clickmore" @click="routerlinkarry('/chainEnterpriselist',{code:list.notionCode,type:1,title:list.notionName})"v-show="list.enterprise[1].list.length>2">更多</span> -->
										</dl>
										<dl>
											<dt>创新</dt>
											<dd>
												 <span class="a-router" :class="userdata.areaKey == item.areaKey?'curp current':''" :key="index" v-for="(item,index) in list.enterprise[2].list" @click="routerlinkid('/enterprises',item.stockCode)" >{{item.title}}</span>
											</dd>
											<!-- <span class="clickmore" @click="routerlinkarry('/chainEnterpriselist',{code:list.notionCode,type:2,title:list.notionName})"v-show="list.enterprise[2].list.length>2">更多</span> -->
										</dl>
										<dl>
											<dt>优质</dt>
											<dd>
												 <span class="a-router" :class="userdata.areaKey == item.areaKey?'curp current':''" :key="index" v-for="(item,index) in list.enterprise[3].list" @click="routerlinkid('/enterprises',item.stockCode)" >{{item.title}}</span>
											</dd>
											<!-- <span class="clickmore" @click="routerlinkarry('/chainEnterpriselist',{code:list.notionCode,type:3,title:list.notionName})"v-show="list.enterprise[3].list.length>2">更多</span> -->
										</dl> 
									</div>
								</div>
								<div class="smbox notioncombox"  :key="index" v-for="(item,index) in list.children">
									<h5 class="title">{{item.notionName}}</h5>
									<div class="oh">
										<span class="clickmore" @click="routerlinkarry('/chainEnterpriselist',{code:item.notionCode,type:0,title:item.notionName})" v-show="item.enterprise[0].list.length>2||item.enterprise[1].list.length>2||item.enterprise[2].list.length>2||item.enterprise[3].list.length>2">更多></span>
										<span class="chainType bu" v-show="item.chainType!=''">{{item.chainType}}</span>
										<!--  v-show="item.chainType == '补链'|| item.enterprise[0].list.length<3||item.enterprise[1].list.length<3||item.enterprise[2].list.length<3||item.enterprise[3].list.length<3" -->
										<span class="focuslink" v-show="item.enterprise[0].list.length<3&&item.enterprise[1].list.length<3&&item.enterprise[2].list.length<3&&item.enterprise[3].list.length<3" @click="tagrouter('/targetEnterprise','0','notion',item.notionCode,item.notionName)">相关企业推荐></span> 
										<dl>
											<dt>上市</dt>
											<dd>
												 <span class="a-router" :class="userdata.areaKey == item1.areaKey?'curp current':''" :key="index" v-for="(item1,index) in item.enterprise[0].list"  @click="routerlinkid('/enterprises',item1.stockCode)">{{item1.title}}</span>
											</dd>
										</dl>
										<dl>
											<dt>龙头</dt>
											<dd>
												 <span class="a-router" :class="userdata.areaKey == item1.areaKey?'curp current':''" :key="index" v-for="(item1,index) in item.enterprise[1].list"  @click="routerlinkid('/enterprises',item1.stockCode)">{{item1.title}}</span>
											</dd>
										</dl>
										<dl>
											<dt>创新</dt>
											<dd>
												 <span class="a-router" :class="userdata.areaKey == item1.areaKey?'curp current':''" :key="index" v-for="(item1,index) in item.enterprise[2].list"  @click="routerlinkid('/enterprises',item1.stockCode)">{{item1.title}}</span>
											</dd>
										</dl>
										<dl>
											<dt>优质</dt>
											<dd>
												 <span class="a-router" :class="userdata.areaKey == item1.areaKey?'curp current':''" :key="index" v-for="(item1,index) in item.enterprise[3].list"  @click="routerlinkid('/enterprises',item1.stockCode)">{{item1.title}}</span>
											</dd>
										</dl>
									</div>
								</div>  
							</div>
						</div> 
					</div>
				 
				</div>
			</div>
			<div v-else class="whitebox heightVh95 container-flex-center">
				<freeUserTips :type="2" :bgtype="14"></freeUserTips>
			</div>
		</div>
	</div>
	</template>
	
	<script>
		import { mapState, mapMutations, mapGetters } from "vuex";
	
		export default {
			name: 'chainEnterprise',
			computed: {
			...mapState({
			isCollapse: (state) => state.isCollapse,
			}),
			...mapGetters(['isCollapse'])
			},
			data() {
				return { 
				areatype:"province",
				isShowProvince:false,
				hiddenCity:true,
				title: "当地产业图谱", 
				calCuData:{id:11,name:'北京',type:'city'},  
				marketStr:false,
				calcuAreaId:"",//计算的城市
				userdata:{currentCity:{isZhixia:false}},
				curWebsite:this.$api.getWebsiteType(), 
				newnotionlist:[],
				tiptext:"",  
				totalPage:1,
				resdata:{},
				chainListCityName:"",
				chainListCityId:0,
				notionlist:[],
				notionlist1:[],
				notionlist2:[],
				notionlist3:[],
				notionlist4:[],
				notionlist5:[],
				notionlist6:[], 
				notioncodeA:'A',
				notioncodeB:'A01',
				notionCode:'A0101',
				namelist:"",
				codelist:"",
				getnotionlist:[],
				notiontext: '',chooseNotionlist:['A','A01','A0101',0,0],
				page: 1,  //显示的是哪一页
				haspage:true,//是否还有下一页
				pageSize: 20, //每一页显示的数据条数
				total: 0, //记录总数 
				maxPage:10,  //最大页数  
				} 
			},  
			beforeCreate() {
				
			},
			created() { 
				this.$nextTick(() => {
						// 禁用右键
						document.oncontextmenu = new Function("event.returnValue=false");
						// 禁用选择
						document.onselectstart = new Function("event.returnValue=false");
				});  
				var _this=this; 
				this.userdata = this.getuseriformation(); 
				if(this.userdata.token){
					// this.calCuData=this.getCalcuCity(this.userdata);
					this.marketStr=this.curWebsite.type == 4 || this.curWebsite.type == 2;
				}
			 
				},
				watch: {
					$route: function(newVal, oldVal) {
						if(this.userdata.groupType != 2 && this.userdata.token){
							this.calcuCityType();
						}
					}
				},
				mounted(){
					document.getElementById('app').style.background = "#f0f3f5";    
				
			  // this.isShowCity=this.userdata.currentCity.noZhixia && (this.curWebsite.type == 1 || this.curWebsite.type == 5 || this.curWebsite.type == 7 || this.curWebsite.type == 6);
					if(this.userdata.groupType != 2 && this.userdata.token){
						this.calcuCityType();
					}
				},
			methods: {  
				//计算到底是本省还是本市
				// calcuCityType(areaid){
				// 	var areatype={type:"",id:areaid};
				// 	if(areaid.length<2){
				// 		areatype.type == 'province';
				// 	}else{
				// 		areatype.type == 'city';
				// 	}
				// },
				calcuCityType(type){
					//如果研究招商投资 本市本省都展示，默认为本省；
					//如果是信贷园区治理 则只展示本市 默认为本市2024.429改为显示本省产业链
					this.bus.$emit('loading', true);   
					this.isShowProvince=this.curWebsite.type == 1 || this.curWebsite.type == 4 || this.curWebsite.type == 5 || this.curWebsite.type == 7 || this.curWebsite.type == 6 || this.curWebsite.type == 8;
					var text1=this.isShowProvince?'province':'city';
					this.areatype = this.$route.query.type ? this.$route.query.type : text1;  
					this.hiddenCity= !this.userdata.currentCity.noZhixia && this.isShowProvince; //当前版本为招商研究投资且为直辖市时不展示本市产业链
					// this.isShowProvince=  this.curWebsite.type == 1 || this.curWebsite.type == 5 || this.curWebsite.type == 7 || this.curWebsite.type == 6; 
					// this.areatype= this.isShowProvince ? 'province' : 'city'; 
					if(this.areatype == 'city'){
						this.calCuData={id:this.userdata.currentCity.id,text:this.userdata.currentCity.text,type:this.userdata.currentCity.type,itemcode:'B-DDTP'};
					}else{
							this.calCuData={id:this.userdata.province,text:this.userdata.provinceText,type:'province',itemcode:'B-DDTP'};
							if(this.curWebsite.type == 6){
								this.calCuData.itemcode='B-BSTP';
							}
					}
					this.getlocalchainlist();
					this.getuserSetNotion();
				},
				//获取用户设置的概念
				getuserSetNotion(){
					var _this=this;
					this.$axios.get(this.$api.cyl.localchain.get()+'?areaId='+this.calCuData.id,{headers:{AuthToken:this.userdata.token}}).then(function(res){
						console.log('用户设置的概念数据',res.data.data)
						if(res.data.success){    
							 _this.namelist=res.data.data.notionText; 
								_this.codelist=res.data.data.notion;
								if(	_this.codelist!=''){ 
									// _this.getdefaultlist(res.data.data.notionText,res.data.data.notion);   
									_this.getnotionnumNew(res.data.data.areaId,res.data.data.notionText,res.data.data.notion); 
								}else{
									_this.tiptext='暂无产业关注概念，请前往设置';
									_this.$message({type:'warning',message:_this.tiptext});
									_this.bus.$emit('loading', false);  
								}
						}else{ 
							
						} 
					});
				},
				//暂用的一级产业到产业链的转换 
				atTimeSelect(data,step){
					if(step == 1){
						this.notionlist1=data.childrenList; this.notioncodeA = data.value;
				 
						this.notionlist2=this.notionlist1[0].newChildrenList; 
						this.notioncodeB = this.notionlist1[0].value;
						this.notionCode=this.notionlist2[0].notionCode;
					}else if(step == 2){
						this.notionlist2=data.newChildrenList;
						this.notioncodeB = data.value;
						this.notionCode=this.notionlist2[0].notionCode;
					}else{ 
							this.notionCode=data.notionCode;
					} 
					this.getlist();
				},
				getNotionTreeList(bigdata,smdata){ 
					var  scData=[];//将二级全部提出
					for(var d=0;d<bigdata.length;d++){
						scData=scData.concat(bigdata[d].children) 	
					}
					//提前在二级里放个新的空数组
					for(var d=0;d<scData.length;d++){
						scData[d].newChildrenList=[];
					}
					//将二级数据code和用户选择的三级数据code相匹配插值
					for(var d=0;d<scData.length;d++){ 
						let scCode=scData[d].value.substr(0,1),matchCode="";
						if(scCode == 'A' || scCode == "C"){
							matchCode=scData[d].value.substr(0,3);
						}else if(scCode == 'B'){
							matchCode=scCode;
						}else{
							matchCode=scData[d].value.substr(0,2); 
						}
						for(var e=0;e<smdata.length;e++){
							let smCode=smdata[e].notionCode.substr(0,1),matchCode1="";
							if(smCode == 'A' || smCode == "C"){
								matchCode1=smdata[e].notionCode.substr(0,3);
							}else if(smCode == 'B'){
								matchCode1=smCode;
							}else{
								matchCode1=smdata[e].notionCode.substr(0,2); 
							}
							if(matchCode == matchCode1){
								// console.log(scData[d].value,smdata[e].notionCode)
								scData[d].newChildrenList.push(smdata[e]);  
							}  
						}
					};
					//移除没有被匹配到的二级数据
					scData=scData.filter(list=>{
						return list.newChildrenList.length>0
					}) 
					//将已经匹配好筛选过的二级数据与一级数据相匹配插值
					for(var d=0;d<bigdata.length;d++){
						bigdata[d].childrenList=[];
					for(var i=0;i<scData.length;i++ ){  
							if(scData[i].value.indexOf(bigdata[d].value) == 0){
									bigdata[d].childrenList.push(scData[i]);
							}
							if(bigdata[d].value == 'E' && scData[i].value.indexOf('B') == 0){
								bigdata[d].childrenList.push(scData[i]);
							} 
						}  
					} 
					//移除没有被匹配到的一级数据
					bigdata=bigdata.filter(list=>{
						return list.childrenList.length>0
					})
					// console.log('获取一级概念数据列',bigdata);
					this.newnotionlist=bigdata;//存值
					this.atTimeSelect(bigdata[0],1); //执行
				},
				getdefaultlist(data){  
					var ajaxurl=this.$api.tag.notion.list() + '?level=3';
					var _this=this;
					this.getAxiosData(ajaxurl,this.userdata.token,function(res){ 
						 
					_this.getNotionTreeList(res.list,data); 
					})  
				},
				//获取用户设置的概念下数量
				getnotionnumNew(areaid,namelist,codelist){   
					var dttd='&notion='+codelist; 
					var _this=this;   
					// var  areaja='&'+this.calCuData.type+'='+this.calCuData.id; 
					var  areaja='&'+this.calCuData.type+'='+this.calCuData.id; 
					let ajaxurld=this.$api.cyl.enterprise.list()+'?page=1&type=0&search=0&calNotion=1&calCNC=1'+dttd+areaja;  
					console.log(ajaxurld);
					this.$axios.get(ajaxurld,{headers:{AuthToken:this.userdata.token}}).then(function(res){    
						var resnumdata=res.data.extend.cityNotionList;
						//console.log('resnumdata',resnumdata)
						_this.getdefaultlist(resnumdata);   
						_this.bus.$emit('loading', false);   
					}).catch(function (error) {
						 //console.log(error);
					});	
				},
				//获取当地图谱列表内容
				getlocalchainlist(pages){
					var _this=this;
					this.$axios.get(this.$api.cyl.localchain.list()+'?areaId='+this.calCuData.id,{headers:{AuthToken:this.userdata.token}}).then(function(res){
						if(res.data.success){   
							_this.resdata=res.data.list;    
						}else{ 
								
						} 
					}).catch(function (error) {}); 
				},
				//产业链公司分布（最底下)
				getlist(pages){
						var _this=this;
						var ajpage=1; 
						if(pages){
							ajpage=pages;
						} 
						this.page=ajpage;
						var notionja =this.splicing('notion',this.notionCode);
						// var ajaxurl = this.$api.cyl.notion.chainenterprise()+'?notion='+this.notionCode+'&cityid='+this.userdata.city;\
						 
						var ajaxurl = this.$api.cyl.notion.chainenterprise()+'?notionCode='+this.notionCode+'&areaId='+this.calCuData.id; 
						console.log(ajaxurl,'a')
						// this.bus.$emit('loading', true);  
						this.$axios.get(ajaxurl,{headers:{AuthToken:this.userdata.token}}).then(function(res){
							_this.bus.$emit('loading', false);   
				   console.log(ajaxurl,res.data);
				   //console.log(res.data);
							_this.notionlist3=res.data.list;
							
						}).catch(function (error) {
							// 请求失败处理 //console.log(error);
						});   
				}, 
			}
		}
	</script>
	
	<style> 
	</style>
	